import { EmploymentTypeDto  } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class EmploymentTypeResponseModel extends GlobalResponseObject{
    data?: EmploymentTypeDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: EmploymentTypeDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}
